import styles from './IntroductionTags.module.css';

interface IntroductionTagsProps {
  tags: { heading: string; items: string[] }[];
}

export const IntroductionTags = ({ tags }: IntroductionTagsProps) => {
  return (
    <div className={styles.tagsGroups}>
      {tags.map(({ heading, items }) => (
        <div className={styles.tagsGroup} key={heading}>
          <h3 className={styles.tagHeading}>{heading}</h3>
          <div className={styles.tagsLayout}>
            {items.map(item => (
              <p key={item} className={styles.tagItem}>
                {item}
              </p>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
